export default {"src":"/_next/static/media/blue-glow.fb573f7c.svg","height":829,"width":833,"blurWidth":0,"blurHeight":0};